import type { PropsWithChildren } from 'react';
import type { MsalAuthenticationResult } from '@azure/msal-react';

import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const SplashScreenFC: React.FC = () => <SplashScreen />;

const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => (
  // TODO: Temporary
  // Replace with custom error page/component once one exists
  <div>Authentication Error: {JSON.stringify(error)}</div>
);

// ----------------------------------------------------------------------

export type AuthGuardProps = PropsWithChildren<{}>;

export function AuthGuard({ children }: AuthGuardProps) {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      loadingComponent={SplashScreenFC}
      errorComponent={ErrorComponent}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
}
